export default __webpack_public_path__ + "static/media/work_3.4948bc68.png";